(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-menu"] && !Shopify.designMode) return;
  try {
    
  class MegaMenu {
    /**
     * Initialize the mega menu
     * Selects all required DOM elements and sets up the initial state
     */
    constructor() {
      // Main container elements
      this.container = document.querySelector('.sib-mobile__container');
      this.backdrop = document.querySelector('.sib-mobile__backdrop');
      this.closeButton = document.querySelector('.sib-mobile__close');
      this.menuToggle = document.querySelector('[data-sib-menu-icon]');

      // Navigation elements
      this.menuLinks = document.querySelectorAll('.sib-mobile__link, .sib-mobile__submenu-link');

      // Track active menus
      this.activeMenus = new Set();

      // Initialize
      this.init();
    }

    /**
     * Initialize all event listeners for the mega menu
     * Handles menu toggling, closing, and keyboard interactions
     */
    init() {
      // Menu toggle
      this.menuToggle?.addEventListener('click', () => this.openMenu());

      // Close button
      this.closeButton?.addEventListener('click', () => this.closeMenu());

      // Backdrop click - ensure event bubbling doesn't interfere
      this.backdrop?.addEventListener('click', (e) => {
        if (e.target === this.backdrop) {
          e.preventDefault();
          e.stopPropagation();
          this.closeMenu();
        }
      });

      // Submenu toggles
      this.menuLinks?.forEach((link) => {
        if (link.classList.contains('has-submenu')) {
          link.addEventListener('click', (e) => this.handleSubmenuToggle(e));
        }
      });

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.closeMenu();
      });
    }

    /**
     * Handle submenu toggle clicks
     * Implements the Reset Scroll Pattern - resets scroll position on every interaction
     * @param {Event} e - Click event object
     */
    handleSubmenuToggle(e) {
      e.preventDefault();
      const link = e.currentTarget;
      const isActive = link.classList.contains('is-active');
      const submenu = link.nextElementSibling;

      // Close any sibling or child menus first
      this.closeRelatedMenus(link);

      // Toggle the clicked menu's state
      link.classList.toggle('is-active');

      if (!isActive && submenu) {
        // Opening a submenu
        this.activeMenus.add(link);
        submenu.style.display = 'block';
      } else {
        // Closing a submenu
        this.activeMenus.delete(link);
        if (submenu) {
          submenu.style.display = 'none';
          // Also close any child submenus
          const childSubmenus = submenu.querySelectorAll('.sib-mobile__submenu');
          const childLinks = submenu.querySelectorAll('.has-submenu');
          childSubmenus.forEach((sub) => (sub.style.display = 'none'));
          childLinks.forEach((link) => link.classList.remove('is-active'));
        }
      }
    }

    /**
     * Close related menus when opening a new one
     * Handles the menu hierarchy to ensure proper menu state
     * @param {HTMLElement} currentLink - The currently clicked menu link
     */
    closeRelatedMenus(currentLink) {
      const isSubmenuLink = currentLink.classList.contains('sib-mobile__submenu-link');
      const currentSubmenu = currentLink.closest('.sib-mobile__submenu');

      this.menuLinks.forEach((link) => {
        if (link === currentLink) return;

        if (isSubmenuLink) {
          // If clicking a submenu link, only close its siblings
          const linkSubmenu = link.closest('.sib-mobile__submenu');
          if (linkSubmenu === currentSubmenu && link.classList.contains('is-active')) {
            link.classList.remove('is-active');
            const submenu = link.nextElementSibling;
            if (submenu) {
              submenu.style.display = 'none';
              // Close any child submenus
              const childSubmenus = submenu.querySelectorAll('.sib-mobile__submenu');
              const childLinks = submenu.querySelectorAll('.has-submenu');
              childSubmenus.forEach((sub) => (sub.style.display = 'none'));
              childLinks.forEach((link) => link.classList.remove('is-active'));
            }
            this.activeMenus.delete(link);
          }
        } else {
          // If clicking a main menu link, close all other main menu items
          if (!isSubmenuLink && link.classList.contains('sib-mobile__link') && link.classList.contains('is-active')) {
            link.classList.remove('is-active');
            const submenu = link.nextElementSibling;
            if (submenu) {
              submenu.style.display = 'none';
              // Close any child submenus
              const childSubmenus = submenu.querySelectorAll('.sib-mobile__submenu');
              const childLinks = submenu.querySelectorAll('.has-submenu');
              childSubmenus.forEach((sub) => (sub.style.display = 'none'));
              childLinks.forEach((link) => link.classList.remove('is-active'));
            }
            this.activeMenus.delete(link);
          }
        }
      });
    }

    /**
     * Close the entire mega menu
     * Resets all states and scroll position
     */
    closeMenu() {
      this.container?.classList.remove('is-visible');
      this.backdrop?.classList.remove('is-visible');
      document.body.style.overflow = '';

      // Reset all submenus
      this.menuLinks?.forEach((link) => {
        link.classList.remove('is-active');
        const submenu = link.nextElementSibling;
        if (submenu?.classList.contains('sib-mobile__submenu')) {
          submenu.style.display = 'none';
        }
      });
      this.activeMenus.clear();
    }

    /**
     * Open the mega menu
     * Sets initial states and scroll position
     */
    openMenu() {
      this.container?.classList.add('is-visible');
      this.backdrop?.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }
  }

  // Initialize the mega menu when DOM is fully loaded
  document.addEventListener('DOMContentLoaded', () => {
    new MegaMenu();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sib-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    handleSIBCarousel();
  });

  function handleSIBCarousel() {
    const carouselSwipers = document.querySelectorAll('[data-sib-carousel-swiper]');

    if (!carouselSwipers.length) return;

    carouselSwipers.forEach((slider) => {
      const container = slider.closest('.sib-carousel__container');
      if (!container) return;

      const sectionId = container.dataset.sectionId;
      let hasUserInteracted = false;

      // Set initial next button color
      const nextButton = container.querySelector(`.sib-carousel-next-${sectionId}`);
      if (nextButton) {
        nextButton.style.color = '#bcd96f';
      }

      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 10,
        preventClicks: true,
        preventClicksPropagation: true,
        a11y: false,
        navigation: {
          nextEl: `.sib-carousel-next-${sectionId}`,
          prevEl: `.sib-carousel-prev-${sectionId}`,
          hideOnClick: false,
          disabledClass: 'swiper-button-disabled',
        },
        on: {
          slideChange: function (swiper) {
            const prevButton = container.querySelector(`.sib-carousel-prev-${sectionId}`);
            const nextButton = container.querySelector(`.sib-carousel-next-${sectionId}`);

            if (!hasUserInteracted) {
              hasUserInteracted = true;
            }

            // Handle beginning of slides
            if (swiper.isBeginning) {
              hasUserInteracted = false;
              if (prevButton) prevButton.style.color = '#d2d2d2';
              if (nextButton) nextButton.style.color = '#bcd96f';
              return;
            }

            // Handle end of slides
            if (swiper.isEnd) {
              if (prevButton) prevButton.style.color = '#bcd96f';
              if (nextButton) nextButton.style.color = '#d2d2d2';
              return;
            }

            // Handle middle slides after user interaction
            if (hasUserInteracted) {
              if (prevButton) prevButton.style.color = '#bcd96f';
              if (nextButton) nextButton.style.color = '#bcd96f';
            }
          },
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
          },
          980: {
            slidesPerView: 4,
          },
        },
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sib-collection-categories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    handleSIBCollectionCategories();
  });

  function handleSIBCollectionCategories() {
    const collectionCategories = document.querySelectorAll('[data-sib-collection-categories-swiper]');

    if (!collectionCategories.length) return;

    collectionCategories.forEach((slider) => {
      const container = slider.closest('.sib-collection-categories__container');
      if (!container) return;

      const sectionId = container.dataset.sectionId;

      new Swiper(slider, {
        slidesPerView: 2,
        spaceBetween: 10,
        preventClicks: true,
        preventClicksPropagation: true,
        a11y: false,
        navigation: {
          nextEl: `.sib-collection-categories-next-${sectionId}`,
          prevEl: `.sib-collection-categories-prev-${sectionId}`,
          hideOnClick: false,
          disabledClass: 'swiper-button-disabled',
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
          },
          980: {
            slidesPerView: 4,
          },
          1024: {
            slidesPerView: 5,
          },
          1200: {
            slidesPerView: 7,
          },
        },
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sib-footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const currentUrl = new URL(window.location.href);
    const searchParams = currentUrl.searchParams.get('customer_posted');
    const emailInput = document.querySelector('.sib-footer__first-bar-newsletter input[type="email"]');
    const submitButton = document.querySelector('.sib-footer__first-bar-newsletter button[type="submit"]');

    if (searchParams === 'true' && emailInput && submitButton) {
      emailInput.disabled = true;
      submitButton.disabled = true;
      emailInput.placeholder = 'You have subscribed';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sib-fresh-picks"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sibFreshPicksSwiper = new Swiper('.sib-freshpicks__image-swiper', {
      slidesPerView: 1,
      spaceBetween: 10,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      loop: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sib-hero-slider"] && !Shopify.designMode) return;
  try {
    
  function handleHeroSlider() {
    const heroSwiper = document.querySelector('[data-sib-hero-swiper]');
    const container = document.querySelector('.sib-hero-slider-container');
    const autoplayEnabled = container.getAttribute('data-sib-hero-slider--auto-play') === 'true';
    const timeout = parseInt(container.getAttribute('data-sib-hero-slider--timeout')) || 5000;

    if (heroSwiper) {
      // Get all custom pagination bullets
      const paginationBullets = heroSwiper.querySelectorAll('.shs__pagination-bullet');
      const slides = heroSwiper.querySelectorAll('.swiper-slide');

      const swiper = new Swiper(heroSwiper, {
        slidesPerView: 1,
        loop: slides.length > 1,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        autoplay:
          autoplayEnabled && slides.length > 1
            ? {
                delay: timeout,
                disableOnInteraction: false,
              }
            : false,
        preventClicks: true,
        a11y: false,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        breakpoints: {
          599: {
            spaceBetween: 20,
          },
        },
        on: {
          init: function (swiper) {
            // Set initial active state
            updateCustomPagination(swiper.realIndex);
          },
          slideChange: function (swiper) {
            // Update active state on slide change
            updateCustomPagination(swiper.realIndex);
          },
        },
      });

      // Function to update custom pagination
      function updateCustomPagination(activeIndex) {
        paginationBullets.forEach((bullet, index) => {
          if (index === activeIndex) {
            bullet.classList.add('active');
          } else {
            bullet.classList.remove('active');
          }
        });
      }

      // Add click handlers to custom bullets (only if they exist)
      if (paginationBullets.length > 0) {
        paginationBullets.forEach((bullet, index) => {
          bullet.addEventListener('click', () => {
            swiper.slideToLoop(index);
          });
        });
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    handleHeroSlider();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sib-mega-menu"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const navbarMenuBtn = document.querySelector('[data-sib-menu-icon] img');
    const mobileMenu = document.querySelector('[data-sib-mobile-menu]');
    const detailsTabs = document.querySelectorAll('.sib__megamenu-mobile-item, .sib__megamenu-mobile-sub-sub-item');

    const closeIcon = '//cdn.shopify.com/s/files/1/0684/1620/9112/files/sib-close-icon.svg';
    const openIcon = '//cdn.shopify.com/s/files/1/0684/1620/9112/files/sib-menu.svg';

    function toggleMobileMenu() {
      if (mobileMenu) {
        mobileMenu.classList.toggle('active');
        navbarMenuBtn.src = mobileMenu.classList.contains('active') ? closeIcon : openIcon;
        navbarMenuBtn.setAttribute('aria-expanded', mobileMenu.classList.contains('active'));
        closeAllDetails();
      }
    }

    function closeAllDetails() {
      detailsTabs.forEach(function (detailsTab) {
        detailsTab.removeAttribute('open');
        detailsTab.querySelector('summary').setAttribute('aria-expanded', 'false');
      });
    }

    function scrollToTop(element) {
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }

    function closeOtherTabs(currentTab) {
      const isParentTab = currentTab.classList.contains('sib__megamenu-mobile-item');
      const parentTab = isParentTab ? currentTab : currentTab.closest('.sib__megamenu-mobile-item');

      detailsTabs.forEach(function (tab) {
        if (tab !== currentTab && tab !== parentTab) {
          if (isParentTab || !parentTab.contains(tab)) {
            tab.removeAttribute('open');
            tab.querySelector('summary').setAttribute('aria-expanded', 'false');
          }
        }
      });
    }

    function toggleDetails(detailsElement, event) {
      const targetElement = event.target;
      const isLink = targetElement.tagName === 'A';
      const isToggleIcon = targetElement.closest('.sib__megamenu-toggle-icons');
      const isSummary = targetElement.tagName === 'SUMMARY' || targetElement.closest('summary');

      if (isLink && !isToggleIcon && !isSummary) {
        // Allow the link to redirect
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      const isOpen = detailsElement.hasAttribute('open');
      detailsElement.toggleAttribute('open');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', !isOpen);

      if (!isOpen) {
        closeOtherTabs(detailsElement);
        scrollToTop(detailsElement);
      }
    }

    if (navbarMenuBtn && mobileMenu) {
      navbarMenuBtn.addEventListener('click', toggleMobileMenu);

      detailsTabs.forEach(function (detailsTab) {
        detailsTab.addEventListener('click', function (event) {
          toggleDetails(this, event);
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sib-testimonial-card"] && !Shopify.designMode) return;
  try {
    
  function initTestimonialsSlider() {
    if (typeof Swiper !== 'undefined') {
      const prevButton = document.querySelector('.testimonials__slider-navigation-prev');
      const nextButton = document.querySelector('.testimonials__slider-navigation-next');
      let hasSlideChanged = false;

      const swiper = new Swiper('.testimonials__slider', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        allowTouchMove: true,
        grabCursor: true,
        speed: 500,
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          980: {
            slidesPerView: 3,
          },
        },
        on: {
          afterInit: function (swiper) {
            updateNavigationVisibility(swiper);
            updateNavigationState(swiper);
          },
          slideChange: function (swiper) {
            hasSlideChanged = true;
            updateNavigationState(swiper);
          },
          touchEnd: function (swiper) {
            if (hasSlideChanged) {
              updateNavigationState(swiper);
            }
          },
        },
      });

      function updateNavigationVisibility(swiper) {
        const totalSlides = document.querySelectorAll('.testimonials__slide').length;
        const navigation = document.querySelector('.testimonials__slider-navigation');

        if (totalSlides <= 3) {
          navigation.style.display = 'none';
        } else {
          navigation.style.display = 'flex';
        }
      }

      function updateNavigationState(swiper) {
        const isBeginning = swiper.isBeginning;
        const isEnd = swiper.isEnd;
        const prevPath = prevButton.querySelector('path');
        const nextPath = nextButton.querySelector('path');

        // Reset colors if we're back at the beginning
        if (isBeginning) {
          prevPath.style.stroke = '#606060';
          prevPath.style.strokeOpacity = '0.51';
          nextPath.style.stroke = '#606060';
          nextPath.style.strokeOpacity = '0.51';
          hasSlideChanged = false;
        }
        // Change to active color if we've moved from the first slide
        else if (hasSlideChanged) {
          prevPath.style.stroke = '#BCD96F';
          prevPath.style.strokeOpacity = '1';
          nextPath.style.stroke = '#BCD96F';
          nextPath.style.strokeOpacity = '1';
        }

        // Handle beginning state
        if (isBeginning) {
          prevButton.style.cursor = 'not-allowed';
          prevButton.style.opacity = '0.5';
        } else {
          prevButton.style.cursor = 'pointer';
          prevButton.style.opacity = '1';
        }

        // Handle end state
        if (isEnd) {
          nextButton.style.cursor = 'not-allowed';
          nextButton.style.opacity = '0.5';
        } else {
          nextButton.style.cursor = 'pointer';
          nextButton.style.opacity = '1';
        }
      }

      // Add click event listeners for navigation
      if (prevButton && nextButton) {
        prevButton.addEventListener('click', () => {
          if (!swiper.isBeginning) {
            swiper.slidePrev();
          }
        });

        nextButton.addEventListener('click', () => {
          if (!swiper.isEnd) {
            swiper.slideNext();
          }
        });
      }

      // Add click event listeners for expanding content
      const contentElements = document.querySelectorAll('.testimonials__card-content');
      contentElements.forEach((content) => {
        content.addEventListener('click', () => {
          content.classList.toggle('expanded');
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', initTestimonialsSlider);
  document.addEventListener('shopify:section:load', initTestimonialsSlider);

  } catch(e) { console.error(e); }
})();
})();
